import React from "react"; // Import the SCSS module
import InputBase from "@mui/material/InputBase";
import SearchIcon from "../../styles/svg/newSearchIcon.svg";

import ClearIcon from "@mui/icons-material/Clear";
import ClearRoundedIcon from '@mui/icons-material/ClearRounded';
import "./search.scss";
import { IconButton } from "@mui/material";

function GlobalSearch({
  searchText,
  handleChange,
  placeholder,
  boardSearch = false,
  onCancel,
  showCancel = false,
  fullWidth = false
}) {
  return (
    <div className={`searchContainer ${fullWidth ? 'fullWidth' : ''}`}>
      <div className="searchIconWrapper">
        <img src={SearchIcon} alt="Search Icon" />
      </div>
      <InputBase
        placeholder={placeholder}
        inputProps={{ "aria-label": "search" }}
        value={searchText}
        onChange={handleChange}
        // type="search"
        className="styledInputBase"
        boardSearch={boardSearch}
        fullWidth={fullWidth}
        endAdornment={
           (showCancel && (
            <IconButton 
              className='cancelIconWrapper'
              onClick={onCancel}
            >
              <ClearRoundedIcon className="mobile-search-cancel-Icon"/>
            </IconButton>
          ))
        }
      />
   
    </div>
  );
}

export default React.memo(GlobalSearch);
